<template>
  <div class="ruleConfigData" style="padding: 0 20px 20px">
    <vxe-toolbar>
      <template #buttons>
        <el-button size="small" type="primary" @click="insertEvent()">新增</el-button>
        <el-button size="small" @click="removeEvent()">删除</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      resizable
      show-overflow
      highlight-hover-row
      ref="xTable"
      max-height="600"
      :data="ruleConfigData"
      :sort-config="{ trigger: 'cell' }"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        showStatus: true,
        icon: 'fa fa-pencil'
      }"
      @edit-closed="editClosedEvent"
    >
      <vxe-column type="checkbox" width="60"></vxe-column>
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-colgroup title="触发条件" align="center">
        <template #default="{ row }">
          <vxe-button type="text" :content="getConditionContent(row)" @click="showConditionBuild(row)"></vxe-button>
        </template>
      </vxe-colgroup>
      <vxe-colgroup title="控制参数" align="center">
        <vxe-table-column field="logic_field1" title="控制逻辑字段1" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatLogicFields(row.logic_field1) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.logic_field1" :filterable="true" @change="selectLogic1(row)" transfer>
              <vxe-option v-for="item in logicFields" :key="item.name" :value="item.name" :label="item.desc"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logic_operator" title="控制符" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatOperator(row.logic_operator) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.logic_operator" :filterable="true" @change="selectOperator(row)" transfer>
              <vxe-option
                v-if="row.logic_field1_condition_type === 'number'"
                v-for="item in operatorNumber"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></vxe-option>
              <vxe-option
                v-if="row.logic_field1_condition_type === 'varchar' || row.logic_field1_condition_type === 'clob'"
                v-for="item in operatorVarchar"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></vxe-option>
              <vxe-option
                v-if="row.logic_field1_condition_type === 'date'"
                v-for="item in operatorDate"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ctrl_source" title="控制来源" :edit-render="{}">
          <template #default="{ row }">
            <span v-if="row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">
              {{ formatCtrlSources(row.ctrl_source) }}
            </span>
          </template>
          <template #edit="{ row }">
            <vxe-select
              v-if="row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              @change="ctrlSourcesChange(row)"
              v-model="row.ctrl_source"
              transfer
            >
              <vxe-option v-for="item in ctrlSources" :key="item.value" :value="item.value" :label="item.label"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logic_field2_extend" title="字典" :edit-render="{}">
          <template #default="{ row }">
            <span v-if="row.ctrl_source === 'DICT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatDict(row.logic_field2_extend)
            }}</span>
            <span v-if="row.ctrl_source === 'ENUM' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatEnum(row.logic_field2_extend)
            }}</span>
          </template>
          <template #edit="{ row }">
            <!--数据字典-->
            <vxe-select
              v-if="row.ctrl_source === 'DICT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              @change="selectDict(row)"
              v-model="row.logic_field2_extend"
              :filterable="true"
              :clearable="true"
              :collapse-tags="true"
              :transfer="true"
            >
              <vxe-option v-for="item in allDataDict" :key="item.key" :value="item.key" :label="item.name"></vxe-option>
            </vxe-select>
            <!--枚举-->
            <vxe-select
              v-if="row.ctrl_source === 'ENUM' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              @change="selectEnumerate(row)"
              v-model="row.logic_field2_extend"
              :filterable="true"
              :clearable="true"
              :collapse-tags="true"
              :transfer="true"
            >
              <vxe-option v-for="item in allEnumerate" :key="item.name" :value="item.name" :label="item.desc"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logic_field2" title="控制逻辑字段2" :edit-render="{}">
          <template #default="{ row }">
            <span v-if="row.ctrl_source === 'MODEL' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatLogicFields(row.logic_field2)
            }}</span>
            <span
              v-if="(row.ctrl_source === 'VALUE' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY') || row.ctrl_source === 'GROOVY_SCRIPT'"
              >{{ row.logic_field2 }}</span
            >
            <span v-if="row.ctrl_source === 'SCRIPT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatLogicFields2(row.logic_field2)
            }}</span>
            <span v-if="row.ctrl_source === 'DICT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatDictValue(row.ctrl_source, row.logic_field2_extend, row.logic_field2, row.dictOptions)
            }}</span>
            <span v-if="row.ctrl_source === 'ENUM' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'">{{
              formatEnumValue(row.ctrl_source, row.logic_field2_extend, row.logic_field2, row.enumerateOptions)
            }}</span>
          </template>
          <template #edit="{ row }">
            <!--模型-->
            <vxe-select
              v-if="row.ctrl_source === 'MODEL' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              v-model="row.logic_field2"
              :filterable="true"
              transfer
            >
              <vxe-option v-for="item in logicFields" :key="item.name" :value="item.name" :label="item.desc"></vxe-option>
            </vxe-select>
            <!---固定值-->
            <vxe-input
              v-if="
                row.ctrl_source === 'GROOVY_SCRIPT' ||
                (row.ctrl_source === 'VALUE' &&
                  row.logic_field1_condition_type !== 'date' &&
                  row.logic_operator !== 'EMPTY' &&
                  row.logic_operator !== 'NOTEMPTY')
              "
              v-model="row.logic_field2"
            ></vxe-input>
            <!--日期--->
            <vxe-input
              v-if="
                row.ctrl_source === 'VALUE' && row.logic_field1_condition_type === 'date' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'
              "
              v-model="row.logic_field2"
              type="date"
              :clearable="true"
              :transfer="true"
            ></vxe-input>
            <!--脚本-->
            <vxe-select
              v-if="row.ctrl_source === 'SCRIPT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              v-model="row.logic_field2"
              :transfer="true"
            >
              <vxe-option v-for="item in scrips" :key="item.key" :value="item.key" :label="item.name"></vxe-option>
            </vxe-select>
            <!--数据字典-->
            <vxe-select
              v-if="row.ctrl_source === 'DICT' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              v-model="row.logic_field2"
              :filterable="true"
              :clearable="true"
              :collapse-tags="true"
              :transfer="true"
              :multiple="row.logic_operator === 'IN' || row.logic_operator === 'NOTIN'"
            >
              <vxe-option v-for="item in row.dictOptions" :key="item.key" :value="item.key" :label="item.name"></vxe-option>
            </vxe-select>
            <!--枚举-->
            <vxe-select
              v-if="row.ctrl_source === 'ENUM' && row.logic_operator !== 'EMPTY' && row.logic_operator !== 'NOTEMPTY'"
              v-model="row.logic_field2"
              :filterable="true"
              :clearable="true"
              :collapse-tags="true"
              :transfer="true"
              :multiple="row.logic_operator === 'IN' || row.logic_operator === 'NOTIN'"
            >
              <vxe-option v-for="item in row.enumerateOptions" :key="item.value" :value="item.value" :label="item.label"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="enable" title="控制方案" :edit-render="{}">
          <template #default="{ row }">
            <span>{{ formatEnable(row.enable) }}</span>
          </template>
          <template #edit="{ row }">
            <vxe-select v-model="row.enable" transfer>
              <vxe-option v-for="item in enableList" :key="item.value" :value="item.value" :label="item.label"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="exception_desc" title="异常描述" :edit-render="{}">
          <template #edit="{ row }">
            <vxe-input v-model="row.exception_desc" type="text"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-colgroup>
    </vxe-table>
    <!--条件-->
    <rule-condition-build-dialog @onConfirm="conditionDialogConfirm" ref="ruleConditionDialog" />
  </div>
</template>

<script>
import form from '@/api/form'
import req from '@/request'
import RuleConditionBuildDialog from '@/components/tenant/rule/RuleConditionBuildDialog.vue'
import { mapState } from 'vuex'
import dictUtils from '@/utils'

export default {
  components: {
    RuleConditionBuildDialog
  },
  name: 'ruleConfigTable',
  data() {
    return {
      conditionFields: [],
      logicFields: [],
      ctrlSources: [
        { value: 'VALUE', label: '固定值' },
        { value: 'MODEL', label: '模型' },
        { value: 'DICT', label: '字典' },
        { value: 'ENUM', label: '枚举' },
        { value: 'GROOVY_SCRIPT', label: 'GROOVY脚本' }
      ],
      enableList: [
        { value: 1, label: '强控制' },
        { value: 2, label: '弱控制' },
        { value: 3, label: '无控制' }
      ],
      operator: [
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'GT', label: '大于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LT', label: '小于' },
        { value: 'LE', label: '小于等于' },
        { value: 'LIKE', label: '相似' },
        { value: 'NOTLIKE', label: '不相似' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'NOTIN', label: '不包含' },
        { value: 'EMPTY', label: '为空' },
        { value: 'NOTEMPTY', label: '不为空' }
      ],
      conditionOperator: [
        { value: 'EQ', label: '等于' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' }
      ],
      operatorNumber: [
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'GT', label: '大于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LT', label: '小于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EMPTY', label: '为空' },
        { value: 'NOTEMPTY', label: '不为空' }
      ],
      operatorVarchar: [
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'LIKE', label: '相似' },
        { value: 'NOTLIKE', label: '不相似' },
        { value: 'LKS', label: '左相似' },
        { value: 'LKE', label: '右相似' },
        { value: 'IN', label: '包含' },
        { value: 'NOTIN', label: '不包含' },
        { value: 'EMPTY', label: '为空' },
        { value: 'NOTEMPTY', label: '不为空' }
      ],
      operatorDate: [
        { value: 'EQ', label: '等于' },
        { value: 'NE', label: '不等于' },
        { value: 'GT', label: '大于' },
        { value: 'GE', label: '大于等于' },
        { value: 'LT', label: '小于' },
        { value: 'LE', label: '小于等于' },
        { value: 'EMPTY', label: '为空' },
        { value: 'NOTEMPTY', label: '不为空' }
      ],
      scrips: [],
      record: {}
    }
  },
  props: {
    ruleConfigData: {
      type: Array,
      default: () => []
    },
    defId: {
      type: String,
      default: () => ''
    },
    scriptOrder: {
      type: Array,
      default: () => []
    }
  },
  mounted() {},
  computed: mapState({
    allDataDict: (state) => state.user.allDataDict,
    allEnumerate: (state) => state.user.allEnumerate
  }),
  watch: {
    defId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        console.log(newVal)
        this.getScriptCtrl(newVal)
        this.getAttrListByDefId(newVal)
      }
    }
  },
  methods: {
    insertEvent(row) {
      this.record = {
        condition_field: '',
        condition_operator: 'EQ',
        condition_ctrl_value: '',
        logic_field1: '',
        logic_field2: '',
        logic_operator: 'EQ',
        ctrl_source: 'VALUE',
        enable: null,
        exception_desc: '',
        logic_field1_condition_type: '',
        logic_field2_extend: null,
        sub_condition_detail: {},
        dictOptions: [],
        enumerateOptions: []
      }
      this.ruleConfigData.push(this.record)
    },
    removeEvent() {
      this.$refs.xTable.removeCheckboxRow()
      this.$emit('dataChange', this.$refs.xTable.getTableData().fullData)
    },
    editClosedEvent({ row, column }) {
      const $table = this.$refs.xTable
      const field = column.property
      // 判断单元格值是否被修改
      if ($table.isUpdateByRow(row, field)) {
        setTimeout(() => {
          // 局部更新单元格为已保存状态
          $table.reloadRow(this.record, null, field)
        }, 300)
      }
    },
    // 获取模板字段名
    getAttrListByDefId(boDefId) {
      let params = {
        defId: boDefId
      }
      form.getAttrListByDefId(params).then((resp) => {
        this.conditionFields = resp.filter(function (item) {
          return item.dataType === 'varchar' || item.dataType === 'number' || item.dataType === 'date' || item.dataType === 'clob'
        })
      })
      form.getAllAttrListByDefId(params).then((res) => {
        this.logicFields = res.filter(function (item) {
          return item.dataType === 'varchar' || item.dataType === 'number' || item.dataType === 'date' || item.dataType === 'clob'
        })
      })
    },
    formatEnable(value) {
      if (value === 1) {
        return '强控制'
      } else if (value === 2) {
        return '弱控制'
      } else if (value === 3) {
        return '无控制'
      }
      return ''
    },
    formatConditionFields(value) {
      let formatField = this.conditionFields.find((item) => item.name === value)
      return formatField ? formatField.desc : ''
    },
    formatConditionOperator(value) {
      let formatConditionOperator = this.conditionOperator.find((item) => item.value === value)
      return formatConditionOperator ? formatConditionOperator.label : ''
    },
    formatOperator(value) {
      let formatOperator = this.operator.find((item) => item.value === value)
      return formatOperator ? formatOperator.label : ''
    },
    formatCtrlSources(value) {
      let ctrlSources = this.ctrlSources.find((item) => item.value === value)
      return ctrlSources ? ctrlSources.label : ''
    },
    formatLogicFields(value) {
      let logicField = this.logicFields.find((item) => item.name === value)
      return logicField ? logicField.desc : ''
    },
    formatLogicFields2(value) {
      let logicField = this.scrips.find((item) => item.key === value)
      return logicField ? logicField.name : ''
    },
    formatDict(value) {
      let logicField = this.allDataDict.find((item) => item.key === value)
      return logicField ? logicField.name : ''
    },
    formatEnum(value) {
      let logicField = this.allEnumerate.find((item) => item.name === value)
      return logicField ? logicField.desc : ''
    },
    formatDictValue(source, extend, value, dict) {
      let dictOptions = dict || []
      if (source !== 'DICT') {
        return
      }
      if (!dictOptions && extend) {
        dictOptions = dictUtils.findDictList(extend, this.allDataDict)
      }
      let desc = []
      if (value && value.constructor === Array) {
        // value = value.join(",");
        value.forEach((v) => {
          let logicField = dictOptions.find((item) => item.key === v)
          if (logicField) {
            desc.push(logicField.name)
          }
        })
        return desc.join(',')
      } else {
        let logicField = dictOptions.find((item) => item.key === value)
        return logicField ? logicField.name : ''
      }
    },
    formatEnumValue(source, extend, value, dict) {
      let enumerateOptions = dict || []
      if (source !== 'ENUM') {
        return
      }
      if (!enumerateOptions && extend) {
        enumerateOptions = dictUtils.getAllEnumerateAttr({
          isShowList: true,
          typeKey: extend,
          allData: this.allEnumerate
        })
      }
      let desc = []
      if (value && value.constructor === Array) {
        value.forEach((v) => {
          let logicField = enumerateOptions.find((item) => item.value === v)
          if (logicField) {
            desc.push(logicField.label)
          }
        })
        return desc.join(',')
      } else {
        let logicField = enumerateOptions.find((item) => item.value === value)
        return logicField ? logicField.label : ''
      }
    },
    ctrlSourcesChange(row) {
      if (row.logic_field1_condition_type === 'date' && row.ctrl_source !== 'VALUE' && row.ctrl_source !== 'MODEL' && row.ctrl_source !== 'GROOVY_SCRIPT') {
        this.$message.warning('选择的控制字段1类型是date，请选择固定值或者模型')
        row.ctrl_source = 'VALUE'
        return
      }
      row.logic_field2 = ''
      row.logic_field2_extend = ''
    },
    /**
     * 获取脚本
     */
    getScriptCtrl(id) {
      let boModel = this.scriptOrder.find((item) => item.id === id)
      req.get('${business}/rule/bus_process_ctrl_rule/getScripts?modelKey=' + boModel.alias).then((res) => {
        this.scrips = res.data
        if (this.scrips && this.scrips.length > 0) {
          this.ctrlSources = [
            { value: 'VALUE', label: '固定值' },
            { value: 'MODEL', label: '模型' },
            { value: 'SCRIPT', label: '脚本' },
            { value: 'DICT', label: '字典' },
            { value: 'ENUM', label: '枚举' },
            { value: 'GROOVY_SCRIPT', label: 'GROOVY脚本' }
          ]
        } else {
          this.ctrlSources = [
            { value: 'VALUE', label: '固定值' },
            { value: 'MODEL', label: '模型' },
            { value: 'DICT', label: '字典' },
            { value: 'ENUM', label: '枚举' },
            { value: 'GROOVY_SCRIPT', label: 'GROOVY脚本' }
          ]
        }
      })
    },
    showConditionBuild(row) {
      this.record = row
      this.$refs.ruleConditionDialog.showDialog(this.conditionFields, JSON.parse(JSON.stringify(row.sub_condition_detail)))
    },
    conditionDialogConfirm(data) {
      let conditionDetail = JSON.parse(data)
      if (conditionDetail && conditionDetail.conditional_relation && conditionDetail.condition) {
        if ((conditionDetail.conditional_relation === 'AND' || conditionDetail.conditional_relation === 'OR') && conditionDetail.condition.length === 0) {
          // 初始化的对象，重置未空
          this.record.sub_condition_detail = {}
        } else {
          this.record.sub_condition_detail = conditionDetail
        }
      }
    },
    selectDict(row) {
      row.logic_field2 = ''
      row.dictOptions = dictUtils.findDictList(row.logic_field2_extend, this.allDataDict)
    },
    selectEnumerate(row) {
      row.logic_field2 = ''
      row.enumerateOptions = dictUtils.getAllEnumerateAttr({
        isShowList: true,
        typeKey: row.logic_field2_extend,
        allData: this.allEnumerate
      })
    },
    selectOperator(row) {
      if (row.ctrl_source !== 'DICT' && row.ctrl_source !== 'ENUM') {
        return
      }
      if (row.logic_operator === 'IN' || row.logic_operator === 'NOTIN') {
        if (row.logic_field2 && row.logic_field2.constructor === String) {
          row.logic_field2 = row.logic_field2.split(',')
        }
      } else {
        if (row.logic_field2 && row.logic_field2.constructor === Array) {
          if (row.logic_field2.length > 0) {
            row.logic_field2 = row.logic_field2[0]
          } else {
            row.logic_field2 = ''
          }
        }
      }
    },
    selectLogic1(row) {
      row.logic_operator = ''
      row.ctrl_source = ''
      let logicField = this.logicFields.find((item) => item.name === row.logic_field1)
      row.logic_field1_condition_type = logicField.dataType
    },
    getConditionContent(row) {
      let conditionCount = 0
      if (row && row.sub_condition_detail && row.sub_condition_detail.condition) {
        conditionCount = row.sub_condition_detail.condition.length
      }
      return '设置条件(' + conditionCount + ')'
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.vxe-dropdown--panel {
  z-index: 2010 !important;
}
//日期框
.vxe-input--panel.type--date,
.vxe-input--panel.type--month,
.vxe-input--panel.type--week,
.vxe-input--panel.type--year {
  z-index: 9998 !important;
}
//选择框
.vxe-select--panel {
  z-index: 9997 !important;
}
.vxe-table--tooltip-wrapper {
  z-index: 9999 !important;
}
.vxe-dropdown--panel {
  z-index: 2010 !important;
}
</style>
